import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';

const ErrorComponent = ({ error, componentStack, resetError }) => {
    useEffect(() => {
        // Single point of error capture with comprehensive context
        Sentry.withScope((scope) => {
            // Add all relevant context
            scope.setExtra('componentStack', componentStack);
            scope.setExtra('errorLocation', window.location.href);
            scope.setExtra('timestamp', new Date().toISOString());
            scope.setTag('error_type', 'react_error_boundary');
            
            // Capture the exception
            Sentry.captureException(error);
        });
        
        // Also log to console for local debugging
        console.error('React Error Boundary caught error:', error);
        
        // Store minimal error info in localStorage for recovery/debugging
        try {
            localStorage.setItem('range-react-error', 'true');
            localStorage.setItem('range-react-error-time', new Date().toISOString());
            if (error?.message) {
                localStorage.setItem('range-react-error-message', error.message.slice(0, 100));
            }
        } catch (e) {
            // Ignore localStorage errors
        }
    }, [error, componentStack]);

    const handleReset = () => {
        try {
            // Clear potentially problematic state
            localStorage.removeItem('HEADLESS_AGE_GATE_PASSED');
            sessionStorage.clear();
            resetError();
        } catch (resetError) {
            console.error('Failed to reset error boundary:', resetError);
            window.location.reload();
        }
    };

    return (
        <div className='headless-error-component'>
            <div className='error-component-title'>
                Unable to load area.
            </div>
            {/* <button onClick={handleReset} className='error-reset-button'>
                Try Again
            </button> */}
        </div>
    );
};

export default ErrorComponent;
